<template>
  <div class="bg-white px-4 py-5 sm:p-4">
      <div class="text-xl font-bold" style="text-align: center;">
        Notificaciones a Jurídica - Embargo N° Proceso: <b style="color: #0e9f6e;">{{ data.numero_proceso }}</b>
      </div>
  </div>

  <div class="bg-white px-3 py-4 sm:p-4">
    <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
      <div class="text-xl font-bold" >
        Valor Actual Embargo: <b style="color: #0e9f6e;"> {{ vueNumberFormat(data.valor_actual, {})}}</b>
      </div>

      <button v-if="viewInterna == 'list'" type="button" @click="changeView('update')" class="flex items-center w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-3 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2" style="white-space: nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 mr-1">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Nueva Notificación
      </button>

      <button @click="viewInterna == 'list' ? handleButtonClick() : changeView('list');"
              class="px-4 py-2 text-white bg-green-500 w-full mt-3 sm:mt-0 sm:w-auto rounded-md hover:bg-green-600 focus:outline-none">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="inline-block w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
        </svg>
        <span class="ml-3">Volver</span>
      </button>
    </div>
    <slot></slot>
  </div>

  <div class="mt-6 overflow-x-auto" v-if="viewInterna == 'list'">
    <table class="w-full table-auto">
      <thead>
      <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
           Número oficio
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Fecha de envío
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Egreso asociado
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Oficio PDF
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Evidencia de envío
        </th>
        <th :class="'px-4 py-3 classTitle'" :style="'styleTitle'">
            Plantilla
        </th>
      </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
        <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium" v-for="(dataNotificacion, indexCollectionData) of collectionData" :key="indexCollectionData">
          <td class="px-4 py-4">
            {{ dataNotificacion.numero_oficio }}
          </td>
          <td class="px-4 py-4">
            {{ dataNotificacion.fecha_envio }}
          </td>
          <td class="px-4 py-4">
            {{ dataNotificacion.egreso ? ('Egreso N° ' + dataNotificacion.egreso.numero) : '-' }}
          </td>
          <td class="px-4 py-4">
              <button v-if="dataNotificacion.url_pdf" @click="descargarDocumentoSoporte(dataNotificacion.url_pdf)"
                      class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
                <span>Descargar PDF</span>
              </button>
              <span v-else>-</span>
          </td>
          <td class="px-4 py-4">
            <button v-if="dataNotificacion.url_evidencia_envio" @click="descargarDocumentoSoporte(dataNotificacion.url_evidencia_envio)"
                    class="px-4 py-2 text-white bg-blue-500 w-full rounded-md hover:bg-blue-600 focus:outline-none">
              <span>Descargar evidencia</span>
            </button>
            <div v-else>
              <input type="file" :id="'archivo_evidencia_' + dataNotificacion.id"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm sm:text-sm">
              <button @click="cargarEvidencia(dataNotificacion.id)"
                      class="mt-1 px-4 py-2 text-white bg-indigo-500 w-full rounded-md hover:bg-indigo-600 focus:outline-none">
                <span>Cargar evidencia</span>
              </button>
            </div>
          </td>
          <td class="px-4 py-4">
            <button @click="generarPlantilla(dataNotificacion)"
                    class="px-4 py-2 text-white bg-yellow-500 w-full rounded-md hover:bg-yellow-600 focus:outline-none">
              <span>Generar oficio</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div v-if="viewInterna == 'update'">
    <div class="bg-white px-4 py-5 sm:p-6" >
      <div class="grid grid-cols-6 gap-6" >
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero_oficio_juridica" class="block text-sm font-medium text-gray-700">Número de oficio <span style="color: red">(*)</span></label>
          <input type="text" id="numero_oficio_juridica" v-model="numero_oficio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_envio_juridica" class="block text-sm font-medium text-gray-700">Fecha de envío <span style="color: red">(*)</span></label>
          <input type="date" id="fecha_envio_juridica" v-model="fecha_envio" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="egreso_asociado" class="block text-sm font-medium text-gray-700">Comprobante de egreso asociado</label>
          <select id="egreso_asociado" v-model="id_egreso_embargo_persona" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
            <option value="">Sin egreso asociado</option>
            <option v-for="egreso of egresosDisponibles" :key="egreso.id" :value="egreso.id">
              Egreso N° {{ egreso.numero }} - {{ egreso.fecha_comprobante }}
            </option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero_cuenta_afectada" class="block text-sm font-medium text-gray-700">N° de cuenta afectada</label>
          <input type="text" id="numero_cuenta_afectada" v-model="numero_cuenta_afectada" placeholder="Ej: 362-25616-6" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          <p class="mt-1 text-xs text-gray-500">Cuenta del ente territorial afectada por el embargo (aparece en el oficio).</p>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="concepto_recurso" class="block text-sm font-medium text-gray-700">Concepto del recurso</label>
          <input type="text" id="concepto_recurso" v-model="concepto_recurso" placeholder="Ej: sobretasa a la gasolina" class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          <p class="mt-1 text-xs text-gray-500">Recurso que maneja la cuenta afectada (aparece en el oficio).</p>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="archivo_notificacion_juridica" class="block text-sm font-medium text-gray-700">Oficio en PDF <span style="color: red">(*)</span></label>
          <input type="file" id="archivo_notificacion_juridica" accept=".pdf"
            @change="documentoSoporte=document.getElementById('archivo_notificacion_juridica').files.item(0);"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          <p class="mt-1 text-xs text-gray-500">Tamaño máximo permitido del archivo adjunto: 10MB.</p>
        </div>
      </div>
    </div>

    <div id="btnUpdate" class="bg-gray-50 px-4 py-3 text-right sm:px-6">
      <button type="button" @click="customSaveData()" class="w-full rounded-md sm:w-1/3 lg:w-1/6 border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium  text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
        Guardar
      </button>
    </div>
  </div>
</template>

<script>
import {saveUpdateData} from "@/layouts/main";
import {ref} from "vue";
import Swal from "sweetalert2";
import { useAPIRest, swal, generateTextError, verifyHttpCode, downloadNotificacionJuridica } from "@/common/constants";
import mime from "mime";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'NotificarJuridicaEmbargoPersonaComponent',
  props: ['data', 'entity', 'authToken'],
  emits: ["updateValues", "watchList"],
  async setup(props, { emit }) {
    const viewInterna = ref('list');
    const numero_oficio = ref('');
    const fecha_envio = ref('');
    const id_egreso_embargo_persona = ref('');
    const numero_cuenta_afectada = ref('');
    const concepto_recurso = ref('');
    const documentoSoporte = ref('');
    const collectionData = ref([]);
    const egresosDisponibles = ref([]);

    const changeView = (tipo_vista) => {
      viewInterna.value = tipo_vista
    }

    const customSaveData = async () =>  {
        try {

          let error = '';
          if (!numero_oficio.value) error += 'El campo número de oficio es obligatorio. <br>';
          if (!fecha_envio.value) error += 'El campo fecha de envío es obligatorio. <br>';
          if (!documentoSoporte.value) error += 'El oficio en PDF es obligatorio. <br>';

          if(error != ''){
            Swal.fire({
              title: error,
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
            return;
          }

          const pesoMaximo = 10 * 1024 * 1024;
          if (documentoSoporte.value.size > pesoMaximo) {
            documentoSoporte.value = undefined;
            await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
            return;
          }

          const newLoadData = new FormData();
          const uniqueFilename = `${uuidv4()}-${documentoSoporte.value.name}`;
          newLoadData.append('file', documentoSoporte.value, uniqueFilename);
          newLoadData.append('id_embargo_persona', props.data.id);
          newLoadData.append('numero_oficio', numero_oficio.value);
          newLoadData.append('fecha_envio', fecha_envio.value);
          if (id_egreso_embargo_persona.value) newLoadData.append('id_egreso_embargo_persona', id_egreso_embargo_persona.value);
          if (numero_cuenta_afectada.value) newLoadData.append('numero_cuenta_afectada', numero_cuenta_afectada.value);
          if (concepto_recurso.value) newLoadData.append('concepto_recurso', concepto_recurso.value);

          const listApi = {
            create: process.env.VUE_APP_NEST_NOTIFICACIONES_JURIDICA_CREATE,
            list: process.env.VUE_APP_NEST_NOTIFICACIONES_JURIDICA_FINDONE,
          };

          await saveUpdateData({
            listApi,
            authToken: props.authToken,
            loadData: newLoadData,
            action: 'crear',
            entity: props.entity,
            view: 'crear',
            options: {
              save: {
                contentType: 'auto'
              },
              update: {
                contentType: 'auto'
              }
            }
          }, undefined, false, false, true);

          numero_oficio.value = '';
          fecha_envio.value = '';
          id_egreso_embargo_persona.value = '';
          numero_cuenta_afectada.value = '';
          concepto_recurso.value = '';
          documentoSoporte.value = undefined;
          viewInterna.value = 'list'

          listData();

        }catch (error) {
          Swal.fire({
              title: 'Error al guardar',
              icon: 'error',
              showCloseButton: true,
              focusConfirm: false,
            })
          console.error('Error al guardar:', error);
        }
    }

    const listData = async () => await useAPIRest(process.env.VUE_APP_NEST_NOTIFICACIONES_JURIDICA_FINDONE.replace(':id', props.data.id), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
          collectionData.value = res;
      });

    const listEgresos = async () => await useAPIRest(process.env.VUE_APP_NEST_EMBARGOPERSONA_FINDONE_EGRESO.replace(':id', props.data.id), 'GET', props.authToken, undefined, undefined, 'application/json')
      .then(res => {
          egresosDisponibles.value = Array.isArray(res) ? res.filter((egreso) => egreso.estado) : [];
      });

    listData();
    listEgresos();

    const handleButtonClick = () => {
        emit('updateValues', { view: 'listar' });
        emit('watchList', { parametro: 'numero_oficio' });
    }

    return {
      changeView,
      viewInterna,
      numero_oficio,
      fecha_envio,
      id_egreso_embargo_persona,
      numero_cuenta_afectada,
      concepto_recurso,
      egresosDisponibles,
      customSaveData,
      collectionData,
      listData,
      listEgresos,
      handleButtonClick,
      documentoSoporte,
      document: document,
    }
  },
  methods: {
    async generarPlantilla(notificacion) {
      try {
        await downloadNotificacionJuridica(notificacion, this.data);
      } catch (error) {
        console.error('Error al generar la plantilla:', error);
        await swal.fire('No fue posible generar la plantilla de notificación.', '', 'error');
      }
    },
    async cargarEvidencia(idNotificacion) {
      const inputArchivo = document.getElementById('archivo_evidencia_' + idNotificacion);
      const archivo = inputArchivo && inputArchivo.files.length ? inputArchivo.files.item(0) : null;

      if (!archivo) {
        await swal.fire('Debe seleccionarse el archivo de evidencia de envío.', '', 'error');
        return;
      }

      const pesoMaximo = 10 * 1024 * 1024;
      if (archivo.size > pesoMaximo) {
        await swal.fire('¡El archivo excede el tamaño de 10MB maximo permitido!', '', 'error');
        return;
      }

      const newLoadData = new FormData();
      const uniqueFilename = `${uuidv4()}-${archivo.name}`;
      newLoadData.append('file', archivo, uniqueFilename);

      const resJSON = await useAPIRest(process.env.VUE_APP_NEST_NOTIFICACIONES_JURIDICA_EVIDENCIA.replace(':id', idNotificacion), 'PATCH', this.authToken, newLoadData, undefined, 'auto');

      if (resJSON && resJSON.id) {
        await swal.fire('Evidencia de envío cargada con éxito', '', 'success');
        this.listData();
      } else {
        const textoError = generateTextError(resJSON);
        await swal.fire(textoError || 'Error al cargar la evidencia', '', 'error');
      }
    },
    async descargarDocumentoSoporte(fileName) {
        await useAPIRest(process.env.VUE_APP_NEST_NOTIFICACIONES_JURIDICA_OBTENERARCHIVO, 'GET', this.authToken, undefined, {
          'url': fileName
        }).then(async resJSON => {
          const {statusCode} = resJSON;
          delete resJSON.statusCode;
          const textoError = generateTextError(resJSON);
          if (verifyHttpCode(statusCode, 'success')) {
            const blob = await resJSON.blob();
            const newBlob = new Blob([blob], {type: mime.getType(fileName)});
            const url = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName.replace('src/assets/documentos_soporte_embargos/personas/notificaciones_juridica/', ''));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else await swal.fire(textoError, '', 'error');
        });
      },
  },
}
</script>
